// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CskH","placeholdersHeader":"styles_placeholdersHeader__2UK6p","editorStyle":"styles_editorStyle__1b8nb","placeholdersBox":"styles_placeholdersBox__2ol63"};